import { stringValue } from 'vega-util';
import { TUPLE, unitName } from '.';
import { SELECTION_ID } from '../../selection';
import { vals } from '../../util';
import { BRUSH } from './interval';
import { TUPLE_FIELDS } from './project';
var point = {
  defined: function defined(selCmpt) {
    return selCmpt.type === 'point';
  },
  signals: function signals(model, selCmpt, _signals) {
    var _a;

    var name = selCmpt.name;
    var fieldsSg = name + TUPLE_FIELDS;
    var project = selCmpt.project;
    var datum = '(item().isVoronoi ? datum.datum : datum)'; // Only add a discrete selection to the store if a datum is present _and_
    // the interaction isn't occurring on a group mark. This guards against
    // polluting interactive state with invalid values in faceted displays
    // as the group marks are also data-driven. We force the update to account
    // for constant null states but varying toggles (e.g., shift-click in
    // whitespace followed by a click in whitespace; the store should only
    // be cleared on the second click).

    var brushes = vals((_a = model.component.selection) !== null && _a !== void 0 ? _a : {}).reduce(function (acc, cmpt) {
      return cmpt.type === 'interval' ? acc.concat(cmpt.name + BRUSH) : acc;
    }, []).map(function (b) {
      return "indexof(item().mark.name, '".concat(b, "') < 0");
    }).join(' && ');
    var test = "datum && item().mark.marktype !== 'group'".concat(brushes ? " && ".concat(brushes) : '');
    var update = "unit: ".concat(unitName(model), ", ");

    if (selCmpt.project.hasSelectionId) {
      update += "".concat(SELECTION_ID, ": ").concat(datum, "[").concat(stringValue(SELECTION_ID), "]");
    } else {
      var values = project.items.map(function (p) {
        var fieldDef = model.fieldDef(p.channel); // Binned fields should capture extents, for a range test against the raw field.

        return (fieldDef === null || fieldDef === void 0 ? void 0 : fieldDef.bin) ? "[".concat(datum, "[").concat(stringValue(model.vgField(p.channel, {})), "], ") + "".concat(datum, "[").concat(stringValue(model.vgField(p.channel, {
          binSuffix: 'end'
        })), "]]") : "".concat(datum, "[").concat(stringValue(p.field), "]");
      }).join(', ');
      update += "fields: ".concat(fieldsSg, ", values: [").concat(values, "]");
    }

    var events = selCmpt.events;
    return _signals.concat([{
      name: name + TUPLE,
      on: events ? [{
        events: events,
        update: "".concat(test, " ? {").concat(update, "} : null"),
        force: true
      }] : []
    }]);
  }
};
export default point;